<template>
    <div class="rp-assignee-image-container" :class="overRideForDesktop ? 'apply-desktop-styles': ''" >
        <img class="rp-assignee-image"  :src="imgSrc" :style="imageStyle" :alt="alt" @error="reportError" v-if="isSrcValid"/>
        <div class="rp-assignee-initial" :style="imageStyle" v-else>{{ initial }}</div>
    </div>
</template>
<script>
export default {

    data() {
        return {
            isSrcValid: this.imgSrc || true
        }
    },
    props: {
        imgSrc: {
            type: String,
            required: true
        },
        height: {
            type: String,
            required: true,
            default: "40"
        },
        width: {
            type: String,
            required: true,
            default: "40"
        },
        radius: {
            type: String
        },
        alt: {
            type: String,
            required: false,
            default:''
        },
        initial: {
            type: String,
            default:'an'
        },
        overRideForDesktop: {
            type: Boolean,
            default: true,
        }
    },
        computed: {
            imageStyle() {
                return {
                    width: this.width + "px",
                    height: this.height + "px",
                    borderRadius: this.width + "px",
                    fontSize: (parseInt(this.width) * 0.325) + "px"
                }
            },
            imageContainerStyle() {
                return {
                    width: (parseInt(this.width) + 1).toString() + "px",
                    height: (parseInt(this.height) + 1).toString() + "px",
                    borderRadius: this.width + "px"
                }
            }

        },
    methods: {
        reportError() {
            //console.log("error to load image.")
            this.isSrcValid = false
        }
    }
}
</script>
<style scoped lang="scss">
.rp-assignee-image-container{
    margin-right:15px;
    &.apply-desktop-styles {
        img, .rp-assignee-initial{
            @include for-size(desktop-up){
                height: 50px !important;
                width: 50px !important;
            }
        }
        .rp-assignee-initial {
            @include for-size(desktop-up){
                border-radius: 50px;
            }
        }
    }
}
.rp-assignee-initial {
    display:flex;align-items:center;
    justify-content: center;
    background:#fff;border:1px solid #666666;
    color: #666666;
    font-size: 13px;
    text-transform: uppercase;
    margin-bottom: 4px;
}
.rp-assignee-image{
    border: 1px solid white;
    background: white;
}
</style>


